import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Row = { id: string; slug: string; status: string; createdAt: string };

export default function PlatformTenantsPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ tenants: Row[] }>(
    "/api/v1/tenant/platform/tenants",
  );
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("platform.tenants.title")}</h1>
      <DataTable
        rows={data?.tenants ?? null}
        loading={loading}
        error={error}
        empty={t("platform.tenants.empty")}
        columns={[
          { header: t("platform.tenants.col.slug"), render: (r) => r.slug },
          { header: t("platform.tenants.col.status"), render: (r) => r.status },
          {
            header: t("platform.tenants.col.created"),
            render: (r) => new Date(r.createdAt).toLocaleDateString(),
          },
        ]}
      />
    </div>
  );
}
